import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import { AuthProvider } from './lib/auth.jsx';
import './styles.css';

// When a new service worker takes control (skipWaiting + clientsClaim are set
// in vite.config.js), reload once so the page is running the code that SW is
// now serving. Without this the tab keeps the old bundle until the user
// happens to refresh twice — which is how a freshly deployed route ends up
// showing "page not found". (2026-08-29)
if ('serviceWorker' in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
